import { VideoTranscriptElement } from '../../models/elements/VideoTranscriptElement';

/**
 * PLAT-11050 / PLAT-11057 — one piece of source media, laid into a reel.
 *
 * Both reel-building paths produce the same thing: a clone of an existing
 * transcript element with only its time, length and media offset changed, and
 * stamped with the Section it belongs to. The clip transcript segment it
 * inherits is left alone and is stale by construction —
 * `RestoreTranscriptFromOriginalCommand` recomputes every segment from media
 * time afterwards, in both paths.
 *
 * The id is dropped deliberately: one source element can be cut into several
 * portions, and two elements sharing an id would collide in the track.
 */
export function buildReelPortion(
  template: VideoTranscriptElement,
  portion: {
    /** Position in the reel's timeline. */
    time: number;
    duration: number;
    /** Where the portion starts in the *source* media. */
    mediaStart: number;
    reelSectionId: string;
  },
): VideoTranscriptElement {
  return new VideoTranscriptElement({
    ...template.getState(),
    id: undefined,
    time: portion.time,
    duration: portion.duration,
    trim_start: portion.mediaStart,
    reelSectionId: portion.reelSectionId,
  });
}
